import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as IconFactory from '../../services/icon.factory';

import * as L from 'leaflet';
import 'leaflet.markercluster';
import 'leaflet-search';

@Component({
    selector: 'kp-map-controls',
    templateUrl: './kp-map-controls.component.html',
    styleUrls: ['./kp-map-controls.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpMapControlsComponent implements OnInit {
    @Input() map: L.Map;
    @Input() isEditable = false;
    @Input() isEditing = false;

    @Output() resetZoom: EventEmitter<void> = new EventEmitter();
    @Output() selectFeature: EventEmitter<void> = new EventEmitter();
    @Output() uploadImg: EventEmitter<File> = new EventEmitter();
    @Output() save: EventEmitter<void> = new EventEmitter();
    @Output() cancel: EventEmitter<void> = new EventEmitter();
    @Output() toggleEditing: EventEmitter<void> = new EventEmitter();

    icons = {
        home: undefined,
        edit: undefined,
        image: undefined,
        add: undefined,
    };

    constructor(private domSanitizer: DomSanitizer) {
        // Have factory create the icons for the UI
        for (const key of Object.keys(this.icons)) {
            this.icons[key] = domSanitizer.bypassSecurityTrustUrl(IconFactory.dataUrlFromIconName(key));
        }
    }

    ngOnInit(): void {
        this.map.on('zoomend', () => {
            this.setLabelSizesByZoom();
        });
        this.setLabelSizesByZoom();
    }

    setLabelSizesByZoom() {
        const pane = this.map.getPane('markerPane');
        const zoom = this.map.getZoom();
        const size = zoom > 18.5 ? (zoom > 19 ? (zoom > 19.5 ? 'large' : 'medium') : 'small') : 'tiny';
        if (pane.getAttribute('data-zoom') !== size) {
            pane.setAttribute('data-zoom', size);
        }
    }

    zoomIn() {
        this.map.zoomIn();
    }
    zoomOut() {
        this.map.zoomOut();
    }

    requestSelectFeature() {
        this.selectFeature.emit();
    }

    requestToggleEditing() {
        this.toggleEditing.emit();
    }
    addImg(target: any) {
        const fl: FileList = target.files;
        const file: File = fl[0];

        if (file) {
            this.uploadImg.emit(file);
        }
    }
    saveChanges() {
        this.save.emit();
    }
    cancelChanges() {
        this.cancel.emit();
    }
}
